export default "__VITE_ASSET__457801ed__"